import { useGet } from "@/apiHooks/HttpFunctions";
import { contactSupportsApi } from "@/apis/apis";
import { formatDateTime } from "@/utils/helper";
import { useSelector } from "react-redux";
import { useCallback, useEffect, useRef, useState } from "react";
import SupportTicketDetail from "@/components/SupportTicketDetail/SupportTicketDetail";
import {
  CONTACT_SUPPORT_STATUS,
  CONTACT_SUPPORT_TYPE,
} from "@/constant/ContactSupport/status";
import { ChangeStatusButton } from "@/components/IconButton/variants";
import Button from "@/components/Button";
import BaseSearch from "@/components/NewTable/BaseSearch";
import NewTicketModal from "@/Modals/CommunicationMGMT/ContactSupports/NewTicketModal";
import { useLocation } from "react-router-dom";

export default function MyTicketPage() {
  const { user } = useSelector((state) => state?.authReducer);
  const modalRef = useRef(null);
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const searchQuery = params.get("filter[keyword]") || "";

  const myTicketURL = `${contactSupportsApi}?assigned_to=${user.id}&filter[keyword]=${searchQuery}`;

  const { data: showData, isFetching: showIsFetching } = useGet({
    apiURL: myTicketURL,
    enabled: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchInterval: true,
  });

  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (showData?.data?.length > 0) {
      setSelectedId(showData.data[0].id);
    }
  }, [showData]);

  const handleOnClickAdd = useCallback(() => modalRef.current?.open(), []);

  return (
    <>
      <div className="flex gap-2">
        <Button
          variant="green-gradient"
          label={"New Ticket"}
          onClick={handleOnClickAdd}
          type="button"
          className="!w-[120px] !text-[14px] mb-3"
        />
        <BaseSearch searchKey="filter[keyword]" placeholder="Search" />
      </div>

      <div className={`-mt-1.5 mb-3 grid grid-cols-12 gap-2 `}>
        {/* Sidebar */}
        <div className={`col-span-3`}>
          <MyTicketsSidebar
            selectedId={selectedId}
            setSelectedId={setSelectedId}
            data={showData}
            showIsFetching={showIsFetching}
          />
        </div>

        {/* Detail Ticket */}
        <div className="col-span-9 p-3">
          {showData?.data?.length > 0 ? (
            <SupportTicketDetail id={selectedId} />
          ) : (
            <p>No data found</p>
          )}
        </div>
      </div>
      <NewTicketModal ref={modalRef} />
    </>
  );
}

function MyTicketsSidebar({ selectedId, setSelectedId, data, showIsFetching }) {
  return (
    <div className={`w-full bg-white border-r border-gray-200 p-1 h-[100vh] `}>
      {!(data?.data?.length > 0) && <p className="mt-1">No data found</p>}
      <ul
        className={`text-sm font-medium text-gray-700 w-full ${
          showIsFetching ? "filter blur-sm" : ""
        }`}
      >
        {data?.data?.map((ticket) => (
          <li key={ticket.id}>
            <button
              type="button"
              className={`px-4 py-2 w-full border rounded mb-1 text-gray-500 hover:bg-gray-100 ${
                selectedId === ticket.id ? "bg-gray-200 text-gray-900" : ""
              }`}
              onClick={() => setSelectedId(ticket.id)}
            >
              <p className="text-left flex items-center gap-2">
                {`${ticket.code} - ${formatDateTime(
                  ticket.created_at,
                  false,
                  false,
                  true
                )}`}
              </p>
              <span className="flex items-center justify-between gap-3">
                {ticket.reason?.name}
                <ChangeStatusButton
                  isActive={ticket.status.type === CONTACT_SUPPORT_TYPE.CLOSED}
                  tooltipText={
                    ticket.status.type === CONTACT_SUPPORT_TYPE.OPEN
                      ? "Open"
                      : "Closed"
                  }
                />
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
